<template>
  <div class="page-permessi">

    <!-- MODAL INSERIMENTO RICHIESTA -->
    <el-dialog :title="($t('ricAuto.newTitle').toUpperCase())" :visible.sync="showModalRichiesta"
      class="custom-dialog" :append-to-body="true" custom-class="offset-7 col-10">
      <el-form class="">
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ricAuto.data') }}
          </div>
          <div class="my-value col-18 no-padding">
           <el-input type="text" placeholder="" v-model="richiesta.dataFornat" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ricAuto.tipoAuto') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-input type="text" placeholder="" v-model="richiesta.desTipoAuto" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ricAuto.localita') }}
          </div>
          <div class="my-value col-18 no-padding">
             <el-input type="text" placeholder="" v-model="richiesta.desLocalita" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ricAuto.torretta') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-input type="text" placeholder="" v-model="richiesta.puntoRicarica" :disabled="true">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ricAuto.info') }}
          </div>
          <div class="my-value col-18 no-padding">
             <el-input type="text" placeholder="" v-model="richiesta.desConnettore" :disabled="true">
            </el-input>
          </div>
        </div>
       
        <div class="elemento row row-custom">
           <div class="my-label col-6 no-padding">
            {{ $t('ricAuto.regole') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-checkbox-group v-model="richiesta.regole" class="riva-header-checkbox">
              <el-checkbox 
                v-for="item in select_regole" 
                :key="item.regola" 
                :label="item.regola">
                {{ item.oreInizio }} - {{ item.oreFine }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="() => {
          let richiesta= {
            regole: [],
            puntoRicarica: '',
            indirizzo: '',
            desConnettore: '',
            oreInizio: '',
            oreFine: '',
            tipoAuto: '',
            desTipoAuto: '',
            localita: '',
            desLocalita: '',
            data: ''
          }
          this.$set(this, 'richiesta', richiesta)
          this.showModalRichiesta = false
        }">
          {{ $t('btn.annulla') }}
        </el-button>
        <el-button class="WEB-button WEB-button-primary" 
          :loading="loading_save" :disabled="loading_save" @click="setRichiesta">
          {{ $t('btn.conferma').toUpperCase() }}
        </el-button>
      </span>
    </el-dialog>

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri"
        @click="() => { filtriActive ? closeFiltri() : openFiltri() }">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
    </div>

    <div class="WEB-body col-24 no-padding">

      <!-- Filtri -->
      <div class="WEB-filtri" v-show="filtriActive">
        <div class="WEB-filtri-content">
          <div class="row">
            <!--<div class="WEB-filtri-title col-24">
              {{$t('filtri.selFiltri')}}
            </div>-->
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.data') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-date-picker class="dt-picker" v-model="filtro.data" type="date" format="dd/MM/yyyy"
                value-format="yyyyMMdd" placeholder="" :clearable="false" :picker-options="{
                  firstDayOfWeek: 1
                }" @change="onDateChange">
              </el-date-picker>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.tipoAuto') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.tipoAuto" class="WEB-select" value-key="tipoAuto" @change="getLocalita">
                <el-option v-for="item in select_auto" :key="item.tipoAuto" :label="item.descrizione" v-loading="loading_auto"
                  :value="item.tipoAuto">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.localita') }}
            </div>
            <div class="WEB-filtri-input col-24" >
              <el-select v-model="filtro.localita" class="WEB-select" value-key="localita" >
                <el-option v-for="item in select_localita" :key="item.localita" :label="item.descrizione" v-loading="loading_localita"
                  :value="item.localita">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.oreInizio') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.oreInizio" class="WEB-select" value-key="localita">
                <el-option v-for="item in select_orario" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ricAuto.oreFine') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.oreFine" class="WEB-select" value-key="localita">
                <el-option v-for="item in select_orario" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="filtri-footer row">
          <div class="col-12 filtri-button-sx">
            <el-button class="WEB-button WEB-button-alternative" @click="svuotaCampi()">
              {{ $t('btn.svuotaCampi') }}
            </el-button>
          </div>
          <div class="col-12 filtri-button-dx">
            <el-button class="WEB-button WEB-button-primary central" @click="cerca()">
              {{ $t('btn.cerca') }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="mask-div" v-show="filtriActive" @click="closeFiltri" />
      <!-- END Filtri -->


      <el-table :data="torrette" highlight-current-row width="100%" v-loading="loading" class="custom-table table-ferie"
        :height="100 % - 56 - 60 - 83">

        <el-table-column prop="desTipoAuto" header-align="center" align="center" :label="($t('ricAuto.tipoAuto'))" min-width="100">
        </el-table-column>
        <el-table-column prop="desLocalita" header-align="center" align="center" :label="($t('ricAuto.localita'))" min-width="200">
        </el-table-column>
        <el-table-column prop="puntoRicarica" header-align="center" align="center" :label="($t('ricAuto.puntoRicarica'))" min-width="200">
        </el-table-column>
        <el-table-column prop="indirizzo" header-align="center" align="center" :label="($t('ricAuto.indirizzo'))" min-width="200">
        </el-table-column>
        <el-table-column prop="desConnettore" header-align="center" align="center" :label="($t('ricAuto.connettore'))" >
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('ricAuto.data'))" width="140">
          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ formatDate(scope.row.data)  }}
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('ricAuto.orario'))" width="140">
          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.oreInizio + ' - ' + scope.row.oreFine }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" width="50">
          <template slot-scope="scope">
            <div class="actions">
              <icon class="pointer" name="riv-add_2" scale="1.1"
                @click.native="() => {
                  openModalRichiesta(scope.row)
                }"></icon>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>    

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PrenotazioneRicAuto',
  props: ['tableHeight'],
  data() {
    return {// filtri
      filtriActive: false,
      filtro: {
        data: '',
        tipoAuto: '',
        localita: '',
        oreInizio: '',
        oreFine: ''
      },
      country: "",
      loading: false,
      torrette: [],
      select_localita: [],
      loading_localita: false,
      select_auto: [],
      loading_auto: false,
      select_orario: [],
      select_regole: [],
      richiesta: {
        regole: [],
        puntoRicarica: '',
        indirizzo: '',
        desConnettore: '',
        oreInizio: '',
        oreFine: '',
        tipoAuto: '',
        desTipoAuto: '',
        localita: '',
        desLocalita: '',
        data: ''
      },
      showModalRichiesta: false,
      loading_save: false
    }
  },
  filters: {
    getCreationDate: function (id) {
      if (id === undefined || id === '' || id.length < 10) {
        return ''
      } else {
        return moment(id, "YYYY-MM-DD").format("DD/MM/YYYY")
      }
    }
  },
  activated: async function () {
    this.country = this.$store.state.country
    // Prendo la data odierna in formato yyyyMMdd con moment
    this.$set(this.filtro, 'data', moment().format('YYYYMMDD'))

    // Popolo select_orario come array di oggetti { codice, descrizione }
    this.select_orario = []
    for (let i = 0; i < 24; i++) {
      const hh = String(i).padStart(2, '0')
      this.select_orario.push({
        codice: `${hh}:00`,
        descrizione: `${hh}:00`
      })
    }

    await this.getAuto()
    await this.getLocalita()
    this.ricerca()
    //this.getCountries()
  },
  deactivated: function () {
    this.country = ""
    this.filtriActive = false
    this.loading = false
    let filtro = {
      data: '',
      tipoAuto: '',
      localita: '',
      oreInizio: '',
      oreFine: ''
    }
    this.$set(this, 'filtro', filtro)
    this.$set(this, 'select_localita', [])
    this.$set(this, 'select_auto', [])
    this.$set(this, 'select_orario', [])
    this.$set(this, 'torrette', [])
    let richiesta= {
      regole: [],
      puntoRicarica: '',
      indirizzo: '',
      desConnettore: '',
      oreInizio: '',
      oreFine: '',
      tipoAuto: '',
      desTipoAuto: '',
      localita: '',
      desLocalita: '',
      data: ''
    }
    this.$set(this, 'richiesta', richiesta)
    this.showModalRichiesta = false
  },
  methods: {
    formatDate: function(date) {
      return date !== '' ? moment(date, "YYYYMMDD").format("DD/MM/YYYY") : ''
    },
    // GESTIONE FILTRI
    openFiltri: function () {
      this.filtriActive = true
    },
    closeFiltri: function () {
      this.filtriActive = false
    },
    svuotaCampi: function () {
      //this.$set(this.filtro, 'data', '')
      //this.$set(this.filtro, 'tipoAuto', '')
      //this.$set(this.filtro, 'localita', '')
      this.$set(this.filtro, 'oreInizio', '')
      this.$set(this.filtro, 'oreFine', '')
    },
    cerca: function () {
      this.filtriActive = false
      this.ricerca()
    },
    // END GESTIONE FILTRI
    async openModalRichiesta(row) {
      console.log('row'+JSON.stringify(row))
      await this.getRegole(row)
      console.log('regole'+JSON.stringify(this.select_regole))
      this.richiesta = {
        ...row,
        dataFornat: this.formatDate(row.data),
        regole: []
      }
      this.showModalRichiesta = true
    },
    async onDateChange() {
      await this.getAuto()
      await this.getLocalita()
    },
    async getAuto() {
      this.loading_auto = true
      this.select_auto = []
      try {
        const response = await this.$http.get("postazioniricaricaauto/" + this.country + '/tipiauto', {
          params: {
            codLang: sessionStorage.getItem('codLang'),
            data: this.filtro.data
          }
        })

        if (response.body.rc === 0) {
          const newList = response.body.data
          this.select_auto = newList

          if (this.filtro.tipoAuto) {
            const exists = newList.some(auto => auto.tipoAuto === this.filtro.tipoAuto)
            if (!exists) {
              this.filtro.tipoAuto = (newList.length > 0) ? newList[0].tipoAuto : null
            }
          } else {
            this.filtro.tipoAuto = (newList.length > 0) ? newList[0].tipoAuto : null
          }
         } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
          this.select_auto = []
        }
      } catch (err) {
        this.loading_auto = []
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: process.env.duration
        })
      } finally {
        this.loading_auto = false
      }
    },
    async getLocalita() {
      this.loading_localita = true
      this.select_localita = []
      try {
        const response = await this.$http.get("postazioniricaricaauto/" + this.country + '/localita', {
          params: {
            codLang: sessionStorage.getItem('codLang'),
            data: this.filtro.data,
            tipoAuto: this.filtro.tipoAuto
          }
        })
        if (response.body.rc === 0) {
          const newList = response.body.data
          this.select_localita = newList

          if (this.filtro.localita) {
            const exists = newList.some(item => item.localita === this.filtro.localita)
            if (!exists) {
              this.filtro.localita = (newList.length > 0) ? newList[0].localita : null
            }
          } else {
            this.filtro.localita = (newList.length > 0) ? newList[0].localita : null
          }
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
          this.select_localita = []
        }
      } catch (err) {
        this.select_localita = []
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: process.env.duration
        })
      } finally {
        this.loading_localita = false
      }
    },
    async getRegole(row) {
      this.select_regole = []
      const response = await this.$http.get("postazioniricaricaauto/" + this.country + '/regolelibere', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          data: this.filtro.data,
          tipoAuto: this.filtro.tipoAuto,
          puntoRicarica: row.puntoRicarica,
          oreInizio: row.oreInizio,
          oreFine: row.oreFine
        }
      })
      if (response.body.rc === 0) {
        this.select_regole = response.body.data
      } else {
        this.$message({
          showClose: true,
          message: response.body.msg[0].msgTxt,
          type: 'error',
          duration: process.env.duration
        })
      }
    },
    async ricerca() {
      this.loading = true
      this.torrette = []

      try {
        const response = await this.$http.get(
          'postazioniricaricaauto/' + this.country + '/puntiricaricaliberi',
          {
            params: {
              data: this.filtro.data,
              localita: this.filtro.localita,
              tipoAuto: this.filtro.tipoAuto,
              oreInizio: this.filtro.oreInizio,
              oreFine: this.filtro.oreFine
            }
          }
        )

        if (response.body.rc === 0) {
          this.$set(this, 'torrette', response.body.data)
        } else {
          this.$set(this, 'torrette', [])
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      } catch (err) {
        this.$set(this, 'torrette', [])
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: process.env.duration
        })
      } finally {
        this.loading = false
      }
    },
    async setRichiesta() {
      this.loading_save = true
      this.select_auto = []

      let payload = {
        data: this.richiesta.data,
        puntoRicarica: this.richiesta.puntoRicarica,
        tipoAuto: this.richiesta.tipoAuto,
        regole: this.richiesta.regole || []   // 👈 array di regole
      }

      try {
        console.log("payload inviato", JSON.stringify(payload))

        const response = await this.$http.post(
          "postazioniricaricaauto/" + this.country + '/prenotazione',
          payload,
          {
            params: {
              codLang: sessionStorage.getItem('codLang')
            }
          }
        )

        if (response.body.rc === 0) {
          let richiesta= {
            regole: [],
            puntoRicarica: '',
            indirizzo: '',
            desConnettore: '',
            oreInizio: '',
            oreFine: '',
            tipoAuto: '',
            desTipoAuto: '',
            localita: '',
            desLocalita: '',
            data: ''
          }
          this.$set(this, 'richiesta', richiesta)
          this.showModalRichiesta = false
          this.ricerca()
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      } catch (err) {
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: process.env.duration
        })
      } finally {
        this.loading_save = false
      }
    },
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

.page-permessi {
  .WEB-actions {
    .prec {
      padding-right: 20px;
      float: none;
    }

    .succ {
      padding-right: 20px;
      float: none;
    }

    .el-date-editor {
      .el-input__inner:hover {
        cursor: pointer;
      }

      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 25px;
        padding-right: 10px;
        width: 150px;
        text-align: center;
      }

      .el-input__prefix {
        left: -5px;

        .el-input__icon {
          line-height: 22px;
        }
      }
    }

    .el-select {

      //margin-left: 20px;
      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 0px;
        padding-right: 10px;
      }

      .el-input__suffix {
        right: -5px;
      }
    }

    .el-checkbox {
      .el-checkbox__inner {
        border-radius: 0px;
      }

      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }

    .header-label {
      .set-font(@size: 14px; @weight: bold);
    }

    .header-value {
      .set-font(@size: 14px; @color: #666);
    }

    .action {
      float: right;
      text-align: right;
    }
  }

  .table-ferie {
    margin-top: 20px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px) - MArgin-top (10px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px - 10px);
  }
}

.autorizzazioni-ferie {
  height: 100%;
  padding: 0;

  .riepilogo {
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;

    .elemento {
      line-height: 40px;

      .titolo {
        height: 60px;
        line-height: 30px;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
      }

      .my-label {
        text-align: left;
        .set-font(@size: 14px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
      }

      .my-value {
        text-align: right;
        .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');

        .el-select {
          .el-input__inner {
            height: 22px;
            line-height: 22px;
            border: 0px;
            border-bottom: 1px solid #e7e7e7;
            border-radius: 0px;
            padding-left: 0px;
            padding-right: 10px;
          }

          .el-input__suffix {
            right: -5px;
          }
        }

        .anno {
          .el-select {
            .el-input__inner {
              width: 55px;
            }
          }
        }

        .stato {
          .el-select {
            width: 90%;
          }
        }
      }
    }
  }

  .elenco {
    height: calc(100vh - 56px - 66px);
    padding: 10px;

    .box {
      padding-top: 10px;
      overflow: auto;
      background-color: #f2f2f2;
      border-radius: 5px;

      .action {
        height: 80px;

        .filter {
          margin-top: 10px;
          text-align: left;
          line-height: 40px;

          .iconArrow {
            cursor: pointer;
            display: inline-block;
            position: relative;
            top: -2px;
            .set-font(@color: @oroRiva, @weight: bold, @family: 'os-regular');
          }

          span {
            .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
          }
        }
      }

      .el-table {
        background-color: #f2f2f2;

        .el-table__header {
          thead {
            tr {
              background-color: #f2f2f2;
            }

            th {
              background-color: #f2f2f2;
            }
          }
        }
      }

      .el-table__body {
        .el-table__row {
          background-color: #f2f2f2;
        }

      }
    }

    .table-ferie {
      height: calc(100vh - 56px - 60px - 82px);
    }
  }

  .note {
    padding: 10px 10px 10px 0px;

    .box {
      border: 1px solid #f2f2f2;

      .note-dip,
      .note-resp {
        .my-label {
          text-align: left;
          margin: 10px;
          border-bottom: 2px solid @greenRiva;

          padding-bottom: 5px;
          .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
        }

        .my-value {
          text-align: left;
          margin: 10px;
          .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');
        }

        height: 150px;
      }
    }

  }

}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.icon-bordered {
  border: 1px solid #ccc;  /* bordo grigio */
  //padding: 4px;            /* spazio interno */
  //border-radius: 4px;      /* angoli arrotondati */
  //display: inline-block;    /* necessario per padding e bordo */
  cursor: pointer;          /* cambia cursore al passaggio */
  transition: all 0.2s;    /* effetto hover morbido */
}

.riva-header-checkbox {
  .el-checkbox {
    .el-checkbox__input {
      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color:  @greenRiva;
        }
      }
      &.is-focus {
        .el-checkbox__inner {
          border-color:  #DCDFE6;
        }
      }
      .el-checkbox__inner:hover {
        border-color:  @greenRiva;
      }
    }
    .el-checkbox__label {
      font-size: 14px;
      font-family: 'os-regular';
      color: #606266;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TorretteRicAuto/PrenotazioneRicAuto.vue